<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.adid" filterable placeholder="请选择">
          <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户UID：</div>
        <el-input v-model="filters.uid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <button class="blue-small-btn ml-auto" @click="editDialog = !editDialog">新建</button>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" >
      <el-table-column prop="aucid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="adid" label="广告ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="title" label="项目" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="底价折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.min_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="默认用户折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.default_discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" width="" align="center">
      </el-table-column>
      <el-table-column label="昵称" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/adUserDetail', query: {uid: scope.row.uid}}">{{scope.row.nickname}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="" label="配置折扣" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.discount}}%</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="打款审核" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">正常</div>
          <div v-if="scope.row.status == 0">失效</div>
        </template>
      </el-table-column>

      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <el-button type="primary" plain size="mini" @click="editDiscount(scope.$index)">编辑</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="配置折扣" :visible.sync="editDialog" size="tiny" width="600px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="adUserConfInfo.aucid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
              <div class="dataForm__name">项目</div>
              <el-select placeholder="请选择" v-model="adUserConfInfo.adid" filterable :disabled="adUserConfInfo.aucid != 0">
                <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists" :key="index"></el-option>
              </el-select>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">用户ID:</div>
            <el-input v-model="adUserConfInfo.uid" placeholder="" size="mini" class="dataForm__input" :disabled="adUserConfInfo.aucid != 0"></el-input>
          </div>
          <div class="dataForm__item mt-16">
            <div class="dataForm__name">用户折扣</div>
            <el-input v-model="adUserConfInfo.discount" placeholder="" size="mini" class="dataForm__input">
              <template slot="append">%</template>
            </el-input>
          </div>
         <div class="dataForm__item mt-16">
            <div class="dataForm__name">是否需要预售</div>
            <el-radio-group v-model="adUserConfInfo.status">
              <div class="dib mr-20">
                <el-radio :label="0">失效</el-radio>
                <el-radio :label="1">正常</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="adUserConfEdit">保存</div>
          <div class="gray-large-btn" @click="editDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import {adUserConfLists, adUserConfEdit, adConciseLists} from '../../../api/api'
import util from '../../../script/util'
export default {
  name: 'adUserConf',
  data () {
    return {
      opid: '',
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        uid: '',
        status: ''
      },
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '正常',
          value: 1
        },
        {
          name: '失效',
          value: 0
        }
      ],
      adLists: [],
      lists: [],
      listLoading: false,
      editDialog: false,
      adUserConfInfo: {
        aucid: 0,
        adid: '',
        uid: '',
        discount: 100,
        status: 1
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    editDiscount (index) {
      this.editDialog = true
      for (let key in this.adUserConfInfo) {
        this.adUserConfInfo[key] = this.lists[index][key]
      }
    },
    adUserConfEdit () {
      let params = {
        aucid: this.adUserConfInfo.aucid,
        adid: this.adUserConfInfo.adid,
        uid: this.adUserConfInfo.uid,
        discount: this.adUserConfInfo.discount,
        status: this.adUserConfInfo.status
      }

      let content = ''

      if (params['discount'] === '') {
        content = '请填写配置折扣'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adUserConfEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.editDialog = false
          for (let key in this.adUserConfInfo) {
            this.adUserConfInfo[key] = ''
          }
          this.adUserConfInfo.aucid = 0
          this.adUserConfInfo.discount = 100
          this.adUserConfInfo.status = 1
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getAdLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      adConciseLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.adLists = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              adid: item.adid
            }
          })
          this.adLists.unshift({
            title: '所有',
            adid: ''
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }

      if (filters.uid !== '') {
        params.uid = filters.uid
      }

      if (filters.status !== '') {
        params.status = filters.status
      }

      this.listLoading = true
      adUserConfLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getAdLists()
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.adid': 'getList',
    'filters.uid': 'getList',
    'filters.status': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adUserConf.vue